import type { Location } from 'react-router-dom'

import type { BidType, MarketProgram } from '@/features/bidding/constants'
import { MarketDate } from '@/features/bidding/utils/date/marketDate'
import type { GroupedBidParams } from '@/features/bidding/utils/groupedBidParams/buildBiddingLinks'
import { logMessageInCoralogix } from '@/features/coralogix/utils/sendExceptions'

/**
 * Extracts GroupedBidParams from URL search parameters.
 *
 * @param location - The current location object from react-router
 * @returns GroupedBidParams object if all required parameters are present, null otherwise
 */
const getGroupedBidParamsFromUrl = (location: Location<any>): GroupedBidParams | null => {
  const searchParams = new URLSearchParams(location.search)

  const deliveryDay = searchParams.get('deliveryDay')
  const marketProgram = searchParams.get('marketProgram')
  const portfolioCode = searchParams.get('portfolioCode')
  const bidType = searchParams.get('bidType')

  if (deliveryDay && marketProgram && portfolioCode && bidType) {
    return {
      marketProgram: marketProgram as MarketProgram,
      deliveryDay: new MarketDate(deliveryDay),
      portfolioCode,
      bidType: bidType as BidType,
    }
  }

  // Capture the current stack trace for debugging purposes
  const stackTrace = new Error().stack || 'Stack trace not available'

  const missingParamsMessage = `Bid create URL params missing: deliveryDay: ${deliveryDay}, marketProgram: ${marketProgram}, portfolioCode: ${portfolioCode}, bidType: ${bidType || 'undefined'}\nCalled from: ${stackTrace}`
  logMessageInCoralogix(missingParamsMessage)
  return null
}

export default getGroupedBidParamsFromUrl
